import React, { useState } from "react";
import Loader from "react-loader-spinner";
import { Link, useHistory } from "react-router-dom";
import { auth } from "../config/firebase";
import "./Login.css";
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [output, setOutputMsg] = useState("");
  const history = useHistory();

  const signIn = (e) => {
    setLoading(true);
    e.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        setLoading(false);
        history.replace("/");

        // setPassword("");
        // setEmail("");
      })
      .catch((err) => {
        setLoading(false);
        setOutputMsg(err.message);
      });
  };

  const register = (e) => {
    setLoading(true);
    e.preventDefault();
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        setLoading(false);
        // setPassword("");
        console.log(auth);
        setOutputMsg("Account has been successfully created");
      })
      .catch((err) => {
        setLoading(false);
        setOutputMsg(err.message);
      });
  };

  return (
    <div className="login">
      {loading && (
        <div className="login__loading">
          <Loader
            type="Oval"
            color="#f0c14b"
            height={100}
            width={100}
            visible={loading}
            // timeout={3000} //3 secs
          />
        </div>
      )}

      <Link to="/">
        <img
          className="login__logo"
          src="https://pngimg.com/uploads/amazon/amazon_PNG1.png"
          alt=""
        />
      </Link>
      <div className="login__container">
        <h1>Sign In</h1>
        <form>
          <h5>E-mail</h5>
          <input
            type="text"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />

          <h5>Password</h5>
          <input
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
          {output && (
            <div
              className={`login__errorMsg ${
                output === "Account has been successfully created" &&
                "login__successMsg"
              }`}
            >
              <p>{output}</p>
            </div>
          )}

          <button type="submit" onClick={signIn} className="login_signInButton">
            Sign In
          </button>
        </form>
        <p>
          By signing-in you are to Amazon's Conditions of Use & Sale. Please see
          our Privacy Notice, our Cookies Notice and our Interest-Based Ads
          Notice.
        </p>
        <button onClick={register} className="login_registerButton">
          Create your Amazon Account
        </button>
      </div>
    </div>
  );
}

export default Login;
